module.exports = __webpack_public_path__ + "media/images/finger-print/congratulation-c71d044af853b761a201fab844a11464.png";